class MainController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService) {

    this.Auth = Auth
    this.$state = $state
    this.User = User
    this.message = 'Welcome to Rangers'
  }
}

export default MainController;


// WEBPACK FOOTER //
// ./client/app/components/main/main.controller.js